module.exports = __webpack_public_path__ + "img/gongsijianjie.ef0ab144.png";